import api from './api';

/** Clasificación de servicios (categoría → subcategoría → familia). */
const serviceClassificationService = {
  async getCategories(params = {}) {
    const response = await api.get('/service-classification/categories', { params });
    return response.data;
  },
  async getCategory(id) {
    const response = await api.get(`/service-classification/categories/${id}`);
    return response.data;
  },
  async createCategory(data) {
    const response = await api.post('/service-classification/categories', data);
    return response.data;
  },
  async updateCategory(id, data) {
    const response = await api.put(`/service-classification/categories/${id}`, data);
    return response.data;
  },
  async deleteCategory(id) {
    const response = await api.delete(`/service-classification/categories/${id}`);
    return response.data;
  },
  async getSubcategories(params = {}) {
    const response = await api.get('/service-classification/subcategories', { params });
    return response.data;
  },
  async getSubcategory(id) {
    const response = await api.get(`/service-classification/subcategories/${id}`);
    return response.data;
  },
  async createSubcategory(data) {
    const response = await api.post('/service-classification/subcategories', data);
    return response.data;
  },
  async updateSubcategory(id, data) {
    const response = await api.put(`/service-classification/subcategories/${id}`, data);
    return response.data;
  },
  async deleteSubcategory(id) {
    const response = await api.delete(`/service-classification/subcategories/${id}`);
    return response.data;
  },
  async getFamilies(params = {}) {
    const response = await api.get('/service-classification/families', { params });
    return response.data;
  },
  async getFamily(id) {
    const response = await api.get(`/service-classification/families/${id}`);
    return response.data;
  },
  async createFamily(data) {
    const response = await api.post('/service-classification/families', data);
    return response.data;
  },
  async updateFamily(id, data) {
    const response = await api.put(`/service-classification/families/${id}`, data);
    return response.data;
  },
  async deleteFamily(id) {
    const response = await api.delete(`/service-classification/families/${id}`);
    return response.data;
  },
  async getHierarchy(params = {}) {
    const response = await api.get('/service-classification/hierarchy', { params });
    return response.data;
  },
  async getFormData(params = {}) {
    const response = await api.get('/service-classification/form-data', { params });
    return response.data;
  },
};

export default serviceClassificationService;
